import { render } from "./BomDependencies.vue?vue&type=template&id=5c5b5f2c"
import script from "./BomDependencies.vue?vue&type=script&lang=js"
export * from "./BomDependencies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__